var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { Dropdown, Icon } from 'semantic-ui-react';
import * as InfoCardApi from '~/Api/InfoCard';
import { CreateSubscriptionRequest, } from '~/Api/Subscriptions/CreateSubscription';
import { UpdateRequest } from '~/Api/TagBlacklist';
import { useApi } from '~/ApiHooks';
import { formatUserMonthYear } from '~/Date';
import { MessageType, useFlashMessage } from '~/FlashMessage';
import { ActionMenuTag } from './ActionMenuTag';
var Content = function (_a) {
    var infoCard = _a.infoCard, onBlacklisted = _a.onBlacklisted;
    var _b = useFlashMessage(), setFlashMessage = _b[1];
    var update = useApi()[0];
    var createSubscription = useApi()[0];
    var blacklistTag = function (tag) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, update(new UpdateRequest([{ tag: { type: tag.type, value: tag.value }, blacklist: 'add' }]))];
                case 1:
                    result = _a.sent();
                    if (result.error === null) {
                        onBlacklisted();
                        setFlashMessage({
                            subtext: "Aktuality t\u00FDkaj\u00EDc\u00ED se ".concat(tag.type === InfoCardApi.TagType.yearMonth ? formatUserMonthYear(tag.date, ['cs-CZ']) : tag.title, " byly skryty"),
                            text: 'Hotovo:',
                            type: MessageType.success,
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var subscribe = function () { return __awaiter(void 0, void 0, void 0, function () {
        var tags, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    tags = infoCard.tags.filter(function (tag) { return tag.type !== InfoCardApi.TagType.yearMonth; }).map(function (tag) { return tag.id; });
                    return [4 /*yield*/, createSubscription(new CreateSubscriptionRequest(tags))];
                case 1:
                    result = _a.sent();
                    if (result.error === null) {
                        setFlashMessage({
                            subtext: 'Přihlášení k odběru aktualit proběhlo úspěšně',
                            text: 'Hotovo:',
                            type: MessageType.success,
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (<>
			<Dropdown.Item data-testid='subscribe' onClick={subscribe}>
				<Icon name='bell'/>
				Přihlásit se k odběru
			</Dropdown.Item>
			<Dropdown.Divider />
			<Dropdown.Header content='Skrýt aktuality které:'/>
			{infoCard.blacklistableTags.map(function (tag) { return (<Dropdown.Item data-testid={"blacklistable-".concat(tag.type)} key={"".concat(tag.type, ":").concat(tag.value)} onClick={function () {
                blacklistTag(tag);
            }}>
					<ActionMenuTag tag={tag}/>
				</Dropdown.Item>); })}
		</>);
};
export var ActionMenu = function (_a) {
    var infoCard = _a.infoCard, onBlacklisted = _a.onBlacklisted;
    var _b = React.useState(false), open = _b[0], setOpen = _b[1];
    return (<Dropdown data-testid='open-infocard-menu' icon='ellipsis vertical' open={open} onClose={function () {
            setOpen(false);
        }} onOpen={function () {
            setOpen(true);
        }}>
			{open ? (<Dropdown.Menu>
					<Content infoCard={infoCard} onBlacklisted={onBlacklisted}/>
				</Dropdown.Menu>) : null}
		</Dropdown>);
};
ActionMenu.displayName = 'InfoCard.ActionMenu';
